import PropTypes from 'prop-types';

const TValue = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
]).isRequired;

const TNoResultSuggestion = PropTypes.shape({
    facetName: PropTypes.string.isRequired,
    facetNameTranslationKey: PropTypes.string.isRequired,
    facetValue: TValue,
    improvementValue: TValue,
    improvementLabel: PropTypes.string.isRequired,
    type: PropTypes.number.isRequired,
    label: TValue,
});

export { TNoResultSuggestion };
